export default {
    message: {
        tiers: {
            t1: {
                label: "スタンドアロン",
                desc: "<p>すべての仮想、Web、およびSaaSアプリケーションへのアクセスを統合し、エンドツーエンドのコンテキストベースのセキュリティ制御を通じて、ユーザー、アプリケーション、およびデータを保護します。</p><p>VPNレス型のプロキシ機能をはじめ、SaaS、仮想、モバイルの各アプリケーションへのSSOを提供するほか、悪意あるコンテンツやキーロガー/画面キャプチャ型のマルウェアなどから企業や組織を守ります。</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>きめ細かなセキュリティを備えた完全なデジタルワークスペースを必要としているが、仮想アプリケーションやデスクトップは必要としていないワーカー向けの包括的なワークスペースソリューションです。</p><p>Workspace Standardの機能に加えて、SaaSおよびWebアプリケーション向けの高度なセキュリティ管理機能や統合エンドポイント管理機能のほか、Content Collaboration Premiumが含まれています。</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Citrix Virtual Apps and Desktops向けのハイブリッド配備オプションを含む、包括的なワークスペースソリューションです。</p><p>Workspace Premiumの機能に加えて、Citrix Virtual Apps and Desktops向けのクラウド管理オプションが含まれています。</p>"
            }
        }
    }
}